import { render, staticRenderFns } from "./DwxxbgsqForm.vue?vue&type=template&id=c70054f4&scoped=true"
import script from "./DwxxbgsqForm.vue?vue&type=script&lang=js"
export * from "./DwxxbgsqForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70054f4",
  null
  
)

export default component.exports